/** @jsxRuntime automatic */
/** @jsxImportSource @fluentui/react-jsx-runtime */

import { OverflowItem, assertSlots } from '@fluentui/react-components';
import type { ReferenceState, ReferenceSlots } from './Reference.types';
import type { JSXElement } from '@fluentui/react-utilities';

export const renderReference_unstable = (state: ReferenceState): JSXElement => {
  assertSlots<ReferenceSlots>(state);

  const { id, shouldUseOverflow } = state;

  const reference = (
    <state.root>
      {state.citation && <state.citation />}
      {state.divider && <state.divider />}
      {state.content && (
        <state.content>
          {state.graphic && <state.graphic />}
          {state.root.children}
        </state.content>
      )}
    </state.root>
  );

  return shouldUseOverflow ? (
    <OverflowItem key={id} id={id}>
      {reference}
    </OverflowItem>
  ) : (
    reference
  );
};
